module.exports = __webpack_public_path__ + "img/Larix.ico.6769f322.png";